exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".success-delivery {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 55rem;\n}\n\n.success-delivery .success-delivery__title {\n  font-family: 'Base_Regular';\n  font-weight: bold;\n  margin-bottom: 2rem;\n}\n\n.success-delivery .success-delivery__info {\n  padding-right: 1rem;\n  font-size: 3.3rem;\n  text-align: center;\n  white-space: pre-line;\n}\n\n", ""]);

// exports
